<template>
    <div id="modal-access-dept" class="modal fade" role="dialog" data-backdrop="static">
        <div class="modal-dialog">
            <!-- Modal content-->
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">Department Access</h4>
                </div>
                <div class="modal-body">
                    <div class="form-group mb-0" v-for="(department, index) in department_props" :key="index">
                        <label>
                            <input type="checkbox" :value="department.id" v-model="selected_departments" />
                            {{department.name}}
                        </label>
                    </div>
                </div>
                <div class="modal-footer">
                    <label style="margin-right:auto;">  
                         <input type="checkbox" v-model="selectall" @change="checkAll()">
                        Select all
                    </label>
                 
                    <button type="button" class="btn btn-success" data-dismiss="modal" @click="submitAccess">Save &amp; Close</button>
                    <button type="button" class="btn" @click="clearAll">Clear All</button>
                </div>
            </div>
        </div>
       
    </div>
</template>

<script>
export default {
    props: ['department_props', 'access_props', 'callback', 'selected_department','category'], //readonly
    data() { //read and write
        return {
            selected_departments: [],
            selectall:false
        }
    },
    methods: {
        submitAccess() {
            // this.department_props;
 
            console.log(this.selected_departments, 'CHILD');
            this.callback(this.selected_departments);
        },
        clearAll() {
            this.selected_departments = []
            this.selectall = false

        },

        checkAll(){
            this.selected_departments = []
            if(this.selectall){
                this.department_props.forEach(element => {
                    this.selected_departments.push(element.id)
                })
            }
            else{
                this.selected_departments = this.selected_department;
            }
            // console.log(this.selectall)
        }
     
    },
    watch: {
        "selected_department": function() {
            this.selected_departments = this.selected_department;
            // console.log( this.selected_departments)

       
         
        },
        selected_departments(data){

            if(this.department_props.length > data.length){
                this.selectall = false;
            }
            else{
                this.selectall = true;

            }

        }
        // "category": function(data){
        //     if(data.name == 'MEMO'){
        //           this.department_props.forEach(element => {
        //             this.selected_departments.push(element.id)
        //         })
        //     }
        //     else{
        //         this.selected_departments = this.selected_department;
        //     }
        // }
    }

  
}
</script>